export enum TagStyleType {
    Basic,
    Basic_rounded,
    Colored
}